import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCWlysLGDbtJnLtnbXuGVlLPh4zm0KzKro",
    authDomain: "kiran-distributor.firebaseapp.com",
    projectId: "kiran-distributor",
    storageBucket: "kiran-distributor.firebasestorage.app",
    messagingSenderId: "284498948113",
    appId: "1:284498948113:web:1df361b69829d2403d41b0",
    measurementId: "G-B5DW7HC0TG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

export { app, analytics, db, auth };